import $ from 'jquery'

function ajaxLoadProducts(search = '', categories = '', brands = '') {
  const data = {
    search: search,
    categories: categories,
    brands: brands,
    action: 'ajax_products_filter'
  };

  $.ajax({
    url: php_vars.ajaxurl,
    type: "POST",
    dataType: 'html',
    data,
    beforeSend: function () {
      $('html, body').animate({
        scrollTop: $('.products-grid__filters').offset().top - 200
      }, 100);
      $('body').find('#products-grid').hide();
      $('body').find('#products-loader').addClass('loading');
    },
    success: function (htmlResponse) {
      if (htmlResponse == "" || htmlResponse == null) {
        $('body').find('#products-grid').html('<div class="grid__column"><p class="no-results">No results found, please try a different search or combination of filters.</p></div>');
      }
      else {
        $('body').find('#products-grid').html(htmlResponse);
      }
    },
    error: function () {
      $('body').find('#products-grid').html('<div class="grid__column"><p class="no-results">No results found.</p></div>');
    },
    complete: function () {
      $('body').find('#products-grid').show();
      $('body').find('#products-loader').removeClass('loading');
    }
  });
}

function filterProducts() {
  if ($('#products-grid').length) {
    let $search = '';
    let $categories = [];
    let $brands = [];
    /* $("#product-search").on('keyup', (function () {
      $search = $('#product-search').val();
      ajaxLoadProducts($search, $categories, $brands);
    })); */
    $(".product-search-submit").on('click', (function () {
      $search = $('#product-search').val();
      ajaxLoadProducts($search, $categories, $brands);
    }));
    $('#product-search').keypress(function (e) {
      var key = e.which;
      if (key == 13) {
        $search = $('#product-search').val();
        ajaxLoadProducts($search, $categories, $brands);
      }
    });  
    $('#product-cats').on('change', function () {
      if ($(this).val() != 'all') {
        if ($.inArray($(this).val(), $categories) === -1) {
          $categories.push($(this).val());
          $('.js-product-active-filters').append('<button class="button js-filter-remove-cat" data-filter-cat="' + $(this).val() + '"><span class="u-sr-only">Remove </span>' + $(this).find('option:selected').text() + '<span class="u-sr-only"> filter</span><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.75854 7.5549L13.2478 3.06567L14.1929 4.01077L9.70364 8.5L14.1929 12.9892L13.2478 13.9343L8.75854 9.4451L4.26932 13.9343L3.32422 12.9892L7.81344 8.5L3.32422 4.01077L4.26932 3.06567L8.75854 7.5549Z" fill="#ED0020"/></svg></button>')
          $('.products-grid__active-filters').addClass('shown')
        }
      }
      ajaxLoadProducts($search, $categories, $brands);
    });
    $('#brands').on('change', function () {
      if ($(this).val() != 'all') {
        if ($.inArray($(this).val(), $brands) === -1) {
          $brands.push($(this).val());
          $('.js-product-active-filters').append('<button class="button js-filter-remove-brand" data-filter-brand="' + $(this).val() + '"><span class="u-sr-only">Remove </span>' + $(this).find('option:selected').text() + '<span class="u-sr-only"> filter</span><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.75854 7.5549L13.2478 3.06567L14.1929 4.01077L9.70364 8.5L14.1929 12.9892L13.2478 13.9343L8.75854 9.4451L4.26932 13.9343L3.32422 12.9892L7.81344 8.5L3.32422 4.01077L4.26932 3.06567L8.75854 7.5549Z" fill="#ED0020"/></svg></button>')
          $('.products-grid__active-filters').addClass('shown')
        }
      }
      ajaxLoadProducts($search, $categories, $brands);
    });
    $(document).on('click', '.js-filter-remove-cat', function (event) {
      $('#product-cats').val('all');
      let val = $(this).data('filter-cat')
      $categories = jQuery.grep($categories, function (value) {
        return value != val;
      });
      $(this).remove()
      if ( $('.js-product-active-filters').html() == '' ) {
        $('.products-grid__active-filters').removeClass('shown')
      }
      ajaxLoadProducts($search, $categories, $brands);
    });
    $(document).on('click', '.js-filter-remove-brand', function (event) {
      $('#brands').val('all');
      let val = $(this).data('filter-brand')
      $brands = jQuery.grep($brands, function (value) {
        return value != val;
      });
      $(this).remove()
      if ($('.js-product-active-filters').html() == '') {
        $('.products-grid__active-filters').removeClass('shown')
      }
      ajaxLoadProducts($search, $categories, $brands);
    });
    $(document).on('click', '.js-clear-product-filter', function (event) {
      event.preventDefault();
      $('.products-grid__selects select').val('all');
      $categories = [];
      $brands = [];
      $('.js-product-active-filters').html('');
      $('.products-grid__active-filters').removeClass('shown')
      ajaxLoadProducts($search, $categories, $brands);
    });
  }
}

$(document).ready(filterProducts)
